import clsx from "clsx";
import {
  FileSize,
  NoData,
  RenderWhen,
  ThreatStatusLabel
} from "../../../../../components";
import { SamplesGridColumnSubtext } from "../../../../search/schema/components";
import { RLCSYaraMatch } from "../../../@types/rldynamicanalysis/yara";
import { convertGoodwareClassification } from "../RlCloudSandboxUtil";
import { SOURCE_TYPE_MAPPING } from "./utils";

export const RLCloudSandboxYaraMatchSchema = {
  fields: [
    {
      name: "file_name",
      displayTitle: "Name",
      sortable: true,
      component: (d: RLCSYaraMatch) => {
        const [classificationLabel] = convertGoodwareClassification(
          d.classification
        );
        return (
          <>
            <div
              className={clsx(
                "samples-grid__name-container",
                "overflow-ellipsis"
              )}
            >
              {d.file_name ? (
                <ThreatStatusLabel
                  showOrb={false}
                  showColor
                  showTitle
                  threatStatus={classificationLabel}
                  labelText={d.file_name}
                  className="overflow-ellipsis"
                />
              ) : (
                <NoData />
              )}
            </div>
            {d.sha1 ? <SamplesGridColumnSubtext text={d.sha1} /> : <NoData />}
          </>
        );
      },
      className: "overflow-ellipsis",
      style: { width: "30%" }
    },
    {
      name: "file_path",
      displayTitle: "Path",
      sortable: true,
      component: (d: RLCSYaraMatch) => (
        <span title={d.file_path}>{d.file_path || <NoData />}</span>
      ),
      className: "overflow-ellipsis",
      style: { width: "30%" }
    },
    {
      name: "sample_type",
      displayTitle: "Format",
      sortable: true,
      component: (d: RLCSYaraMatch) => d.sample_type || <NoData />,
      className: "overflow-ellipsis",
      style: { width: "10%" }
    },
    {
      name: "sample_size",
      displayTitle: "Size",
      sortable: true,
      component: (d: RLCSYaraMatch) =>
        d.sample_size ? <FileSize value={d.sample_size} /> : <NoData />,
      className: "numeric-cell",
      style: { textAlign: "center", width: "10%" }
    },
    {
      name: "source_type",
      displayTitle: "Source Type",
      sortable: true,
      component: (d: RLCSYaraMatch) =>
        SOURCE_TYPE_MAPPING[d.source_type] || <NoData />,
      style: { width: "20%" }
    }
  ]
};
